import { DeleteRequest, GetListRequest, GetListResponse } from "./api.model";

export type EventCategoryGetListRequest = GetListRequest<EventCategoryGetListRequestFilter>;
export type EventCategoryGetListResponse = GetListResponse<EventCategory>;
export type EventCategoryDeleteRequest = DeleteRequest;

export interface EventCategoryGetListRequestFilter {
  name?: string | null;
  isEnabled?: boolean | null;

  /** @format int64 */
  sortOrder?: number | null;
}


export interface EventCategory {
  name?: string | null;
  isEnabled?: boolean | null;

  /** @format int64 */
  sortOrder?: number | null;

  /** @format int64 */
  id?: number;

  /** @format byte */
  system_RowVersion?: string | null;
}

export interface EventCategoryInsertRequest {
  name?: string | null;
  isEnabled?: boolean | null;

  /** @format int64 */
  sortOrder?: number | null;
  eventCategory_Translations: EventCategoryTranslationInsertRequest[];
}

export interface EventCategoryTranslationInsertRequest {
  translation?: string | null;
  name?: string | null;

  /** @format int64 */
  refLanguage_Id?: number | null;
  isEnabled?: boolean | null;
}
